
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar1 from "./Navbar";
import Table from "react-bootstrap/Table";
import { Col, Container, Row, Button, Form, Pagination, Spinner } from "react-bootstrap";
import Header from "./Header";
import axios from "axios";
import { useUser } from "./context/UserContext"; // ✅ Corrected Import Path
import { getBaseUrl } from "../api";
import { CalendarFill, PersonFill, TelephoneFill } from "react-bootstrap-icons";

    
    function View() {
        const { loggedInUser, crn } = useUser(); // Access UserContext and shared CRN
        const [patientsData, setPatientsData] = useState([]);
        const [searchTerm, setSearchTerm] = useState("");
        const [currentPage, setCurrentPage] = useState(1);
        const recordsPerPage = 10;
        const navigate = useNavigate();
        const [loading, setLoading] = useState(false);
    const baseUrl = getBaseUrl();
        function wotzDate(now)
    {
        let geo= "";
    let nd=new Date(now);
    const ld=nd.toLocaleString('en-US', { timeZone:"Asia/Calcutta"});
    let csa=ld.split(",");
    let dsa=csa[0].split("/");
    let mm=dsa[0].toString();
    if ( mm.length < 2 )
      mm="0"+mm;
    let dd=dsa[1].toString();
    if ( dd.length < 2 )
      dd="0"+dd;
    if ( undefined == geo || null == geo || "DEFAULT" == geo )
      geo="India";
    if ( "India" == geo )
      now=dd+"-"+mm+"-"+dsa[2];
    else
      now=dsa[2]+"-"+mm+"-"+dd;
    
    return now;
    }
    
    const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0"); // Ensure 2-digit day
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure 2-digit month
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
};


        useEffect(() => {
            if (!crn) return;
            
            const requestData = {
                crn: crn,
                action: "R",
                object: "dial",
                user_id:loggedInUser,
            };
            
            axios.post(`https://${baseUrl}/request`, requestData)
            .then((response) => {
                console.log("Database Fetch Response:", response.data);
                if (response.data && response.data.response && Array.isArray(response.data.response)) {
                    const parsedData = response.data.response.map(patient => {
                        let parsedDetails = [];
                        let diabeticDuration = "N/A"; // Default value
                        
                        try {
                            parsedDetails = patient.details ? JSON.parse(patient.details) : [];
                            if (Array.isArray(parsedDetails) && parsedDetails.length > 0 && parsedDetails[0].dur) {
                                diabeticDuration = parsedDetails[0].dur;
                            }
                        } catch (error) {
                            console.error("Error parsing details JSON:", error, patient.details);
                        }
                        
                        return {
                            ...patient,
                            duration: diabeticDuration // Extracted duration
                        };
                    });
                     // **Reverse the order to show the latest first**
                    setPatientsData(parsedData.reverse());
                } else {
                    console.error("Invalid response format", response.data);
                }
            })
            .catch((error) => console.error("Error fetching patient data:", error));
    }, [crn]);
    
    const handleDelete = (index) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this patient?");
        if (confirmDelete) {
            const patientToDelete = patientsData[index];
            const deleteRequestData = {
                sequence: patientToDelete.sequence,
                crn: patientToDelete.crn,
                action: "D",
                object: "dial",
                date: wotzDate(patientToDelete.date),
                patient_name:patientToDelete.patient_name,
                patient_age:patientToDelete.patient_age,
                patient_gender:patientToDelete.patient_gender
            };
            
            axios.post(`https://${baseUrl}/request`, deleteRequestData)
                .then((response) => {
                    console.log("Delete Response:", response.data);
                    if (response.data && response.data.status === "00") {
                        const updatedPatients = patientsData.filter((_, i) => i !== index);
                        setPatientsData(updatedPatients);
                    } else {
                        console.error("Error deleting patient record", response.data);
                    }
                })
                .catch((error) => console.error("Error deleting patient:", error));
        }
    };
    
    
    const handleView = async (index) => {
        try {
            const selectedPatient = filteredPatients[indexOfFirstRecord + index];
            if (!selectedPatient) {
                console.error("Selected patient is undefined");
                return;
            }
            
            const requestData = {
                sequence: selectedPatient.sequence,
                crn: selectedPatient.crn,
                action: "R",
                object: "dial"
            };
            
            const response = await axios.post(`https://${baseUrl}/request`, requestData);
            console.log("View Patient Response:", response.data);
            
            if (response.data && response.data.status === "00" && response.data.response.length > 0) {
                const patientResponse = response.data.response[0];
            
                let patientDetails = [];
                if (patientResponse.details) {
                    try {
                        patientDetails = JSON.parse(patientResponse.details);
                    } catch (error) {
                        console.error("Error parsing patient details JSON:", error);
                        patientDetails = []; // Fallback to empty array
                    }
                }
                navigate("/viewdet", { state: { patientData: patientDetails } });
            } else {
                console.error("Error fetching patient details: Invalid response format", response.data);
            }
        } catch (error) {
            console.error("Error fetching patient details:", error);
        }
    };
    
    // Filtering Logic
    const filteredPatients = patientsData.filter(patient =>
        (patient.patient_name && patient.patient_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (patient.patient_mobile && patient.patient_mobile.includes(searchTerm)) ||
        (patient.patient_age && patient.patient_age.toString().includes(searchTerm)) ||
        (patient.patient_gender && patient.patient_gender.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (patient.duration && patient.duration.toString().includes(searchTerm))
    );
    
    // Pagination calculations
    const totalPages = Math.ceil(filteredPatients.length / recordsPerPage);
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredPatients.slice(indexOfFirstRecord, indexOfLastRecord);
    
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <>
            <Header/>
            <Navbar1 />
            <Container className="mt-4">
                <Row className="align-items-center mb-3">
                    <Col md="2" xs="4">
                        <Button variant="danger" onClick={() => navigate("/home")}> ← Back </Button>
                    </Col>

                    <Col md="4" xs="6" className="text-center">
                        <h2 className="mb-0">View Section</h2>
                    </Col>

                    <Col md="6" xs="12" className="mt-3">
                        <Form.Control
                            type="text"
                            placeholder="Search by Name or Phone Number"
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setCurrentPage(1);
                            }}
                        />
                    </Col>
                </Row>

                <Row>
                {currentRecords.length === 0 ? (
        <p className="text-center text-danger fw-bold"></p>
      ) : (
        currentRecords.map((patient, index) => (
          <div key={index} className="record-container p-3 my-2 border rounded shadow-sm bg-white">
            <Row className="align-items-center">
              {/* Left Section (Details) */}
              <Col md={8} xs={8}>
                <Row>
                <Col xs={12} className="mb-2">
                    <CalendarFill className="me-2 text-primary" />
                    <span className="record-label fw-bold">Date: </span>
                    <span className="record-value">
                    {patient.date ? formatDate(patient.date) : "N/A"}
                    </span>
                  </Col>
                  <Col xs={12} className="mb-2">
                    <PersonFill className="me-2 text-success" />
                    <span className="record-label fw-bold">Patient Name: </span>
                    <span className="record-value">{patient.patient_name}</span>
                  </Col>
                  <Col xs={12} className="mb-2">
                    <TelephoneFill className="me-2" style={{color:"orange"}} />
                    <span className="record-label fw-bold">Phone: </span>
                    <span className="record-value">{patient.patient_mobile}</span>
                  </Col>
                  {/* Uncomment if needed */}
                  {/* <Col xs={12}>
                    <span className="record-label">🩺 Diab. Duration: </span>
                    <span className="record-value">{patient.duration} Years</span>
                  </Col> */}
                </Row>
              </Col>

              {/* Right Section (Buttons) */}
              <Col md={4} xs={4}className="d-flex align-items-center justify-content-end">
                <Button variant="success" size="sm" className="me-2" onClick={() => handleView(index)}>
                  View
                </Button>
                <Button variant="danger" size="sm" onClick={() => handleDelete(index)}>
                  Delete
                </Button>
              </Col>
            </Row>
          </div>
        ))
      )}
                </Row>

                  {/* **Pagination Section** */}
                   {totalPages > 1 && (
                     <Row>
                         <Col className="d-flex justify-content-center">
                             <Pagination>
                                 <Pagination.First onClick={() => paginate(1)} disabled={currentPage === 1} />
                                 <Pagination.Prev onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} />
                                 {[...Array(totalPages)].map((_, i) => (
                                     <Pagination.Item
                                         key={i + 1}
                                         active={i + 1 === currentPage}
                                         onClick={() => paginate(i + 1)}
                                     >
                                         {i + 1}
                                     </Pagination.Item>
                                 ))}

                                 <Pagination.Next onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} />
                                <Pagination.Last onClick={() => paginate(totalPages)} disabled={currentPage === totalPages} />
                             </Pagination>
                         </Col>
                     </Row>
                 )} 
            </Container>
        </>
    );
}

export default View;